import { emailClickData } from "@redotech/redo-marketing-email-builder-common/clickable-element-primitives";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getEmailTemplateClickTrackingData = {
  name: "getEmailTemplateClickTrackingData" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: z.object({ results: z.array(emailClickData) }),
};
